import { Icons, LabelChipV2, Typography, Stack } from '@cast/design-system';
import { HPAScalingPolicyType } from '@cast/types';

import { HighlightedItem } from './HighlightedItem';

type PolicyData = { value: number; periodSeconds: number };

const formatPolicyType = (type: HPAScalingPolicyType) =>
  type === HPAScalingPolicyType.PODS_SCALING_POLICY
    ? 'PODS'
    : type === HPAScalingPolicyType.PERCENT_SCALING_POLICY
    ? 'PERCENT'
    : type;

const formatPolicyValue = (
  value: number | undefined,
  type: HPAScalingPolicyType | undefined
) => {
  if (value == null) return '-';
  return type === HPAScalingPolicyType.PERCENT_SCALING_POLICY
    ? `${value}%`
    : String(value);
};

type ScalingPolicyTypeItemProps = {
  type: HPAScalingPolicyType;
  prev: PolicyData | undefined;
  curr: PolicyData | undefined;
  titleSuffix: string;
};

export const ScalingPolicyTypeItem = ({
  type,
  prev,
  curr,
  titleSuffix,
}: ScalingPolicyTypeItemProps) => (
  <Stack>
    <Typography variant="P10R" color="grey.600">
      {titleSuffix} {formatPolicyType(type)} POLICY:
    </Typography>
    {!prev && !curr ? (
      <LabelChipV2
        color="grey"
        size="s"
        label="Not configured"
        sx={{ mt: 10 }}
      />
    ) : (
      <Stack direction="row" gap={24}>
        <HighlightedItem label="value">
          <Stack direction="row" alignItems="center" gap={8}>
            <Typography variant="P10R">
              {formatPolicyValue(prev?.value, type)}
            </Typography>
            <Icons.ArrowRight
              css={({ palette }) => ({ color: palette.grey[400] })}
            />
            <Typography variant="P10R">
              {formatPolicyValue(curr?.value, type)}
            </Typography>
          </Stack>
        </HighlightedItem>
        <HighlightedItem label="period">
          <Stack direction="row" alignItems="center" gap={8}>
            <Typography variant="P10R">
              {prev ? `${prev.periodSeconds}s` : '-'}
            </Typography>
            <Icons.ArrowRight
              css={({ palette }) => ({ color: palette.grey[400] })}
            />
            <Typography variant="P10R">
              {curr ? `${curr.periodSeconds}s` : '-'}
            </Typography>
          </Stack>
        </HighlightedItem>
      </Stack>
    )}
  </Stack>
);
